export const IS_LOADING_WHATSAPP = "IS_LOADING_WHATSAPP";
export const WHATS_APP_SUCCESS = "WHATS_APP_SUCCESS";
export const WHATS_APP_FALED = "WHATS_APP_FALED";

export const IS_LOADING_EMAIL = "IS_LOADING_EMAIL";
export const EMAIL_SUCCESS = "EMAIL_SUCCESS";
export const EMAIL_FALED = "EMAIL_FALED";

export const IS_LOADING_GET_EMAIL = "IS_LOADING_GET_EMAIL";
export const GET_EMAIL_SUCCESS = "GET_EMAIL_SUCCESS";
export const GET_EMAIL_FALED = "GET_EMAIL_FALED";


export const OMNI_SUCCESS = "OMNI_SUCCESS";
export const OMNI_FALED = "OMNI_FALED";



